import Vue from 'vue'

const luPFEntityType = {
  state: {
    luPFEntityType: [],
    selectedLuPFEntityType: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luPFEntityType(state) {
      return state.luPFEntityType
    },
    selectedLuPFEntityType(state) {
      return state.selectedLuPFEntityType
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luPFEntityType(state, payload) {
      state.luPFEntityType = payload
    },
    selectedLuPFEntityType(state, payload) {
      state.selectedLuPFEntityType = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuPFEntityType(context, payload) {
      context.commit('selectedLuPFEntityType', payload)
    },
    loadLuPFEntityType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuPFEntityType'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luPFEntityType', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuPFEntityType(context, payload) {
      if (
        context.state.selectedLuPFEntityType &&
        context.state.selectedLuPFEntityType.ID
      ) {
        context.dispatch(
          'loadSelectedLuPFEntityType',
          context.state.selectedLuPFEntityType.ID
        )
      }
    },
    loadSelectedLuPFEntityType(context, payload) {
      if (
        context.state.selectedLuPFEntityType &&
        context.state.selectedLuPFEntityType.ID != payload
      ) {
        context.commit('selected', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuPFEntityType/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuPFEntityType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuPFEntityType(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuPFEntityType')
      })
    },
    updateLuPFEntityType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuPFEntityType/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Lu P F Entity Type updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuPFEntityType')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createLuPFEntityType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuPFEntityType`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Lu P F Entity Type created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuPFEntityType')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveLuPFEntityType(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuPFEntityType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuPFEntityType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuPFEntityType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuPFEntityType/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Lu P F Entity Type deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuPFEntityType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default luPFEntityType
